export class MockGenealogyService {
  getConstellations = jasmine.createSpy('getConstellations');
}
